import { Layout, Link } from '@loomhq/lens';
import React, { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { COMMENTS_BREAKPOINT } from 'constants/breakpoints';
import { deleteReplyCreator } from 'creators/comments';
import { getCloudfrontURI } from 'utilities/avatar';
import { getFormattedDateForHeader, userCanDelete } from 'utilities/comments';

import useMedia from 'hooks/useMedia';
import { selectCurrentUserIsOwner } from 'selectors/videoPlayer';

import DeleteUndoPlaceholder from '../delete-undo-placeholder';
import PostBody from '../post-body';

import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const AVATAR_SIZE_FULL = 4;
const AVATAR_SIZE_SMALL = 3;

const Reply = props => {
  const { reply } = props;

  const dispatch = useDispatch();
  const currentUserIsOwner = useSelector(selectCurrentUserIsOwner);
  const user = useSelector(state => state.user);

  const replyRef = useRef(null);

  const avatar = reply.avatar && reply.avatar.thumb;

  const deleteReply = () => {
    dispatch(deleteReplyCreator(reply));
  };

  const fullSize = useMedia(
    [`(min-width: ${COMMENTS_BREAKPOINT}px)`],
    [true],
    false
  );
  const avatarSize = fullSize ? AVATAR_SIZE_FULL : AVATAR_SIZE_SMALL;

  function VisibleReply() {
    return (
      <>
        <UserAvatar
          className={styles.avatar}
          avatarSrc={avatar && getCloudfrontURI(avatar)}
          name={reply.user_name}
          avatarSize={avatarSize}
        />
        <div ref={replyRef} className={styles.commentReply}>
          <div className={styles.replyHeader}>
            <span className={styles.userName}> {reply.user_name} </span>
          </div>
          <PostBody content={reply}></PostBody>
          <div className={styles.dimmedText}>
            <span>{getFormattedDateForHeader(reply.createdAt)}</span>
            {userCanDelete(reply, currentUserIsOwner, user) && (
              <Link
                variant="neutral"
                className={styles.deleteLink}
                onClick={deleteReply}
              >
                Delete
              </Link>
            )}
          </div>
        </div>
      </>
    );
  }

  return (
    <Layout
      gap="medium"
      className={styles.replyContainer}
      id={`reply-${reply.id}`}
    >
      {reply.locallyDeleted ? (
        <DeleteUndoPlaceholder commentOrReply={reply}></DeleteUndoPlaceholder>
      ) : (
        VisibleReply()
      )}
    </Layout>
  );
};

export default Reply;
